// action type /timeentry/list/summary/daily
export const TIME_ENTRIES_SUMMARY_DAILY_REQUEST =
  "TIME_ENTRIES_SUMMARY_DAILY_REQUEST";
export const TIME_ENTRIES_SUMMARY_DAILY_SUCCESS =
  "TIME_ENTRIES_SUMMARY_DAILY_SUCCESS";
export const TIME_ENTRIES_SUMMARY_DAILY_FAILURE =
  "TIME_ENTRIES_SUMMARY_DAILY_FAILURE";
